export { getElementFromPointWithoutHoneypot } from '../../honey-pot-fix/get-element-from-point-without-honey-pot';